<template>
  <nav class="tt-bottom-nav" aria-label="Navegación del técnico">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="tt-bottom-nav__item"
      :class="{ 'tt-bottom-nav__item--active': isActive(item) }"
    >
      <span class="mdi tt-bottom-nav__icon" :class="item.icon"></span>
      <span class="tt-bottom-nav__label">{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const items = [
  { label: 'Tickets', icon: 'mdi-clipboard-list-outline', to: '/tecnico', match: (p) => p === '/tecnico' || p.startsWith('/tecnico/ticket') },
  { label: 'Calendario', icon: 'mdi-calendar-month-outline', to: '/tecnico/calendario', match: (p) => p.startsWith('/tecnico/calendario') },
  { label: 'Cuenta', icon: 'mdi-account-circle-outline', to: '/cuenta', match: (p) => p.startsWith('/cuenta') },
]

const isActive = (item) => item.match(route.path)
</script>

<style scoped>
/* Solo móvil: en escritorio el técnico usa el sidebar con los mismos tres destinos. */
.tt-bottom-nav { display: none; }

@media (max-width: 768px) {
  .tt-bottom-nav {
    display: flex; position: fixed; left: 0; right: 0; bottom: 0; z-index: 1000;
    height: calc(56px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background: var(--side-panel); border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
  .tt-bottom-nav__item {
    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px;
    color: rgba(255, 255, 255, 0.6); text-decoration: none;
  }
  .tt-bottom-nav__item--active { color: #fff; }
  .tt-bottom-nav__icon { font-size: 22px; line-height: 1; }
  .tt-bottom-nav__label { font: 500 10px Inter, sans-serif; }
}
</style>